import ErrorMessageBox from "components/ErrorMessageBox"
import { formatMessage } from "i18n/CurrentLocale"


export const FormInvalidMessage = ({ errors, showValidation }: { errors: any, showValidation: boolean }) => {
    return showValidation && !!(errors && Object.keys(errors).length) && (
        <div>
            <ErrorMessageBox errorMessage={formatMessage({ id: 'REGISTRATION_FORM_CONTAINS_ERRORS' })} />
        </div>
    )
}
